import { Grid, MenuItem } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

import Button from "../../../../../../components/Form/Button";
import { getBrandCustom } from "../../../../../../util/getCustomColor";

export const AddTaskButton = styled(Button)(() => ({
  whiteSpace: "nowrap",
}));

export const ExpandAllButtonContent = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 10,
}));

export const ExpandAllTitle = styled("span")(() => ({
  font: "700 20px/28px Manrope",
  color: colors.gray600,
}));

export const TasksAndMilestonesInfo = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 16,
}));

export const InfoIcon = styled("img")(() => ({
  cursor: "help",
}));

export const InfoTitle = styled("span")(() => ({
  color: colors.gray800,
  font: "600 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));

export const TooltipContentWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}));

export const TooltipBottomText = styled("span")(() => ({
  paddingTop: "12px",
}));

export const PeriodMenuItem = styled(MenuItem)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));

export const MenuItemTitle = styled("span")(() => ({
  font: "600 12px Manrope",
  lineHeight: "16px",
  letterSpacing: "0.5px",
}));

export const GridItem = styled(Grid)(() => ({
  marginBottom: "16px",
  "@media (max-width: 959px)": {
    marginBottom: 0,
  },
}));

export const BoxTimezone = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  fontSize: 12,
  color: colors.gray500,
  gap: 4,
});

const styles = (isOnViewMode: boolean) =>
  makeStyles(() => ({
    container: {
      position: "relative",
      minHeight: isOnViewMode ? "" : "calc(100vh - 300px)",
      paddingBottom: "40px",
      display: "flex",
      flexDirection: "column",
      gap: "40px",
    },
    title: {
      fontFamily: "Manrope",
      fontSize: "20px",
      fontWeight: 700,
      lineHeight: "28px",
      color: "#465869",
    },
    addTaskWrapper: {
      backgroundColor: `${colors.gray50}`,
      border: `1px solid ${colors.gray200}`,
      padding: "20px",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    containerStackDates: {
      backgroundColor: getBrandCustom("headerBackgroundColor", "#EDF5FB"),
      borderRadius: "12px",
      padding: "16px 24px 0px 24px",
      marginTop: "17px",
    },
    divider: {
      margin: "0px 16px",
    },
    dividerHorizontal: {
      margin: "16px 0px",
      height: "1px",
    },
    defaultButtonWithIcon: {
      backgroundColor: "#308CDB",
      border: "1px solid #20639D",
      color: "#fff",
      boxSizing: "border-box",
      borderRadius: "4px",
      padding: "5.33px",
      "&:hover": {
        backgroundColor: "#308CDB",
        border: "1px solid #20639D",
      },
    },
    defaultCheckboxLabel: {
      "& span": {
        fontWeight: 500,
      },
    },
    containerTasks: {
      marginBottom: "24px",
    },
    buttons: {
      position: "absolute",
      bottom: 0,
      right: 0,
    },
    expandAllWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "#EDF5FB",
      borderRadius: "8px",
      padding: "4px 16px",
      marginBottom: "20px",
    },
    expandAllButton: {
      padding: "10px 0",
      color: "#465869",
      font: "500 12px/16px Manrope",
    },
    skeleton: {
      marginTop: "12px",
    },
    selectAnAgentInfo: {
      borderRadius: "8px",
      border: "1px solid #8AB1D5",
      backgroundColor: "#E6EEF6",
      padding: "12px",
      color: "#003C74",
      display: "flex",
      alignItems: "start",
      gap: "12px",
    },
    selectAnAgentInfoIcon: {
      flexGrow: 0,
    },
    selectAnAgentInfoText: {
      flexGrow: 1,
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 400,
      letterSpacing: "0.25px",
    },
  }));

export default styles;
